// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { createBrowserRouter, RouterProvider, type RouteObject } from "react-router";

import routes from "./pages/route"
import axios from 'axios';
import { APIURL } from './config';
// import { StrictMode } from 'react';


axios.defaults.withCredentials = true;
axios.defaults.baseURL = APIURL;

// https://www.heropy.dev/p/9tesDt
const router = createBrowserRouter([
  ...routes,
] as Array<RouteObject>,{
  basename:'/',
});

const app = createRoot(document.getElementById('root')!);
app.render(<>
  {/* <StrictMode>    */}
    <RouterProvider router={router} />
  {/* </StrictMode>, */}
  </>
)
